<!--<div class="panel">-->
<!--  <div class="header">-->
<!--    <span class="tooltip bottom" [attr.aria-label]="tooltip">{{ name }}</span>-->
<!--&lt;!&ndash;    <button style="float: right" (click)="hide.emit()"><img src="/assets/x.svg" style="height: 18px;"></button>&ndash;&gt;-->
<!--  </div>-->
<!--  <div>-->
<ng-content></ng-content>
<!--  </div>-->
<!--</div>-->
